import Skeleton from "./Skeleton"

export default function TopLoading({}) {
  return (
    <div className="px-4">
      <Skeleton w={200} h={38} style="my-3" />
      <Skeleton h={500} />
    </div>
  )
}
